<template>
    <!-- open-on-focus -->
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- the navigation across menu options is not available with tab but with the arrows keys -->
    <div tabindex="0" v-bind="attrs" v-on="on" :class="$vuetify.theme.dark ? 'tabindex-handler-light' : 'tabindex-handler' " class="ms-3" >
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class=""
        dot
      >
        <v-avatar
          size="40px"
          color="primary"
          class="v-avatar-light-bg primary--text"
        >
          <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
        </v-avatar>
      </v-badge>
    </div>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            color="primary"
            class="v-avatar-light-bg primary--text"
          >
            <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ user_data.username }}
          </span>
          <small class="text--disabled text-capitalize">{{ roleParser(user_data.role) | translate }}</small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <router-link
        to="/profile"
        class="d-flex align-center text-decoration-none"
      >
        <v-list-item href="#">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiAccountOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('Perfil')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>

      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item @click="logoutUser">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{$t('Salir')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from '@mdi/js'

export default {
  methods: {
    async logoutUser() {
      this.$store.dispatch('session/logoutUser')
      this.$router.push('/login')
    },
    roleParser(role) {
      const roles = {
        0: "Administrador",
				1: "Representante de país",
				2: "Coordinador regional",
				3: "Representante escolar",
      }
      return roles[role]
    }
  },
  computed: {
    user_data() { return this.$store.getters['session/userData']()}
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },
}
</script>

<style lang="scss">
.tabindex-handler{
  &:focus {
    border-radius: 20px;
    outline: 1px solid var(--v-primary-base);
  }
}

.tabindex-handler-light{
  &:focus {
    border-radius: 20px;
    outline: 2px solid white;
  }
}

.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
